import React from 'react';
import PageTitle from '../components/sections/PageTitle';
import '../styles/contact.css';

const Contact: React.FC = () => {
  const contactInfo = [
    {
      icon: 'bi bi-geo-alt',
      title: 'Address',
      content: 'Khilgaon, Dhaka-1219, Bangladesh',
      link: null
    },
    {
      icon: 'bi bi-telephone',
      title: 'Call/WhatsApp',
      content: '+8801735066946',
      link: 'tel:+8801735066946'
    },
    {
      icon: 'bi bi-envelope',
      title: 'Email',
      content: 'rezwanhasan262@gmail.com',
      link: 'mailto:rezwanhasan262@gmail.com'
    },
    {
      icon: 'bi bi-linkedin',
      title: 'LinkedIn',
      content: 'md-rezuwan-hassan/',
      link: 'https://www.linkedin.com/in/md-rezuwan-hassan/'
    }
  ];

  return (
    <>
      <PageTitle
        title="Contact"
        description="Feel free to reach out to me for any inquiries, collaborations, or just to say hello! I'm always open to new opportunities and connections."
        breadcrumbs={[
          { name: 'Home', path: '/' },
          { name: 'Contact' }
        ]}
      />

      <section className="contact section">
        <div className="container">
          <div className="row gy-5">
            {/* Contact Information */}
            <div className="col-lg-12">
              <div className="contact-info" data-aos="fade-up">
                <h3 className="contact-title">Get In Touch</h3>
                <p className="contact-description">
                  I'm always open to discussing new opportunities, interesting projects, creative ideas, or opportunities to be part of your visions.
                </p>

                <div className="row">
                  <div className="col-md-6">
                    {/* First column: Address and Call/WhatsApp */}
                    <div className="contact-column">
                      {contactInfo.slice(0, 2).map((item, index) => (
                        <div key={index} className="contact-item" data-aos="fade-up" data-aos-delay={index * 100}>
                          <div className="contact-icon">
                            <i className={item.icon}></i>
                          </div>
                          <div className="contact-details">
                            <h4>{item.title}</h4>
                            {item.link ? (
                              <a href={item.link} target="_blank" rel="noopener noreferrer">
                                {item.content}
                              </a>
                            ) : (
                              <p>{item.content}</p>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-md-6">
                    {/* Second column: Email and LinkedIn */}
                    <div className="contact-column">
                      {contactInfo.slice(2, 4).map((item, index) => (
                        <div key={index} className="contact-item" data-aos="fade-up" data-aos-delay={(index + 2) * 100}>
                          <div className="contact-icon">
                            <i className={item.icon}></i>
                          </div>
                          <div className="contact-details">
                            <h4>{item.title}</h4>
                            {item.link ? (
                              <a href={item.link} target="_blank" rel="noopener noreferrer">
                                {item.content}
                              </a>
                            ) : (
                              <p>{item.content}</p>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-12 contact-form-section">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

// Contact Form Component
const ContactForm: React.FC = () => {
  const [formData, setFormData] = React.useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSendMessage = () => {
    const { name, email, subject, message } = formData;
    
    // Validate required fields
    if (!name || !email || !message) {
      alert('Please fill in all required fields (Name, Email, and Message).');
      return;
    }

    // Create Gmail compose URL
    const gmailSubject = subject || `Message from ${name} - Portfolio Contact`;
    const gmailBody = `Hello Md. Rezuwan Hassan,

${message}

Best regards,
${name}
Email: ${email}`;

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=rezwanhasan262@gmail.com&su=${encodeURIComponent(gmailSubject)}&body=${encodeURIComponent(gmailBody)}`;
    
    // Open Gmail in new tab
    window.open(gmailUrl, '_blank');
    
    // Clear form after sending
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="contact-form" data-aos="fade-up" data-aos-delay="300">
      <h3 className="form-title">Send me a Message</h3>
      <p className="form-description">
        Fill out the form below and I'll get back to you as soon as possible.
      </p>
      
      <div className="form-container">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="name">Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Your Name"
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="your.email@example.com"
                required
              />
            </div>
          </div>
        </div>
        
        <div className="form-group">
          <label htmlFor="subject">Subject</label>
          <input
            type="text"
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={handleInputChange}
            placeholder="Message Subject (Optional)"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="message">Message *</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            placeholder="Write your message here..."
            rows={6}
            required
          ></textarea>
        </div>
        
        <div className="form-actions">
          <button 
            type="button" 
            className="btn-send"
            onClick={handleSendMessage}
          >
            <i className="bi bi-send"></i>
            Send Message
          </button>
        </div>
      </div>
    </div>
  );
};

export default Contact; 